import { Injectable } from '@angular/core';
import { Request, Headers, Response } from '@angular/http';
import { HttpClient } from './services/http.service';
import { Observable } from 'rxjs/Rx';
import { AsyncSubject ,Subject } from 'rxjs';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database-deprecated';
@Injectable()
export class AppService {
    public subject =new Subject()
    constructor(private httpClient: HttpClient, private firebasedb: AngularFireDatabase) {
       
    }
    public getbaseUrl(): Observable<any> {
        return this.firebasedb.object('talktiveParents/urlConfig').map(items => {
            return items;
        });

    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        let err = JSON.parse(error._body);
        return Observable.throw(err);
    }
    //sb page count to show red dot
    getCount(event){
        this.subject.next(event);
    }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/app.service.ts